import {
  Component,
  ElementRef,
  HostBinding,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Renderer2,
  SimpleChanges,
} from '@angular/core';
import { Router } from '@angular/router';

import { Subscription } from 'rxjs';
import { INavData } from './app-sidebar-nav';
import { AppSidebarService } from './app-sidebar.service';

@Component({
  selector: 'app-sidebar-nav, cui-sidebar-nav',
  templateUrl: './app-sidebar-nav.component.html',
})
export class AppSidebarNavComponent implements OnChanges, OnInit, OnDestroy {
  @Input() navItems: INavData[] = [];

  @HostBinding('attr.role')
  @Input()
  role = 'nav';

  @HostBinding('class')
  get sidebarNavClasses() {
    return this.sidebarOpen ? 'sidebar-nav' : 'small-sidebar-scroll';
  }

  public navItemsArray: INavData[] = [];
  sidebarOpen = true;
  private sidebarStatusSubscription: Subscription;

  constructor(
    public router: Router,
    public sidebarService: AppSidebarService,
    private renderer: Renderer2,
    private el: ElementRef,
  ) {}

  public ngOnChanges(changes: SimpleChanges): void {
    this.navItemsArray = Array.isArray(this.navItems) ? this.navItems.slice() : [];
  }

  ngOnInit() {
    this.sidebarStatusSubscription = this.sidebarService.sidebarStatus$.subscribe(status => {
      this.sidebarOpen = status;
    });
  }

  ngOnDestroy() {
    this.sidebarStatusSubscription.unsubscribe();
  }
}
